import VoltageRequests from '../../server/voltage';
import { addLoading, removeLoading } from './loading';

export const getListVoltage = (
  limit,
  skip,
  search,
  orderBy = 'DESC',
  field = 'createdAt',
  loading = true,
) => async (dispatch) => {
  if (loading) dispatch(addLoading());
  try {
    const result = await VoltageRequests.getListVoltage(limit, skip, search, orderBy, field);
    return result;
  } finally {
    if (loading) dispatch(removeLoading());
  }
};

export const getOptionsVoltage = search => async () => {
  const listApplicationType = await VoltageRequests.getOptionsVoltage(search);
  return listApplicationType;
};

export const createVoltage = newVoltage => async (dispatch) => {
  dispatch(addLoading());
  try {
    await VoltageRequests.createVoltage(newVoltage);
  } finally {
    dispatch(removeLoading());
  }
};

export const updateVoltage = updVoltage => async (dispatch) => {
  dispatch(addLoading());
  try {
    const result = await VoltageRequests.updateVoltage(updVoltage);
    return result;
  } finally {
    dispatch(removeLoading());
  }
};
